import { API } from '@/shared/api';
import { PaymentInterval } from '@/shared/types/Billing';

export type PendingSubscriptionCheckout = {
  interval: PaymentInterval.Month | PaymentInterval.Year;
  latestTransactionIdBeforeCheckout?: string;
  productId: string;
  createdAt: number;
};

type RememberPendingSubscriptionCheckout = Pick<PendingSubscriptionCheckout, 'interval' | 'productId'>;

const KEY = 'rask_pending_subscription_checkout';
const TTL_MS = 24 * 60 * 60 * 1000;

export const readPendingSubscriptionCheckout = (): null | PendingSubscriptionCheckout => {
  try {
    const raw = localStorage.getItem(KEY);

    if (!raw) return null;

    return JSON.parse(raw) as PendingSubscriptionCheckout;
  } catch {
    return null;
  }
};

export const rememberPendingSubscriptionCheckout = async ({
  interval,
  productId,
}: RememberPendingSubscriptionCheckout) => {
  const latestPaymentInfo = await API.getLatestPaymentInfo().catch(() => null);

  if (!latestPaymentInfo) return;

  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({
        interval,
        latestTransactionIdBeforeCheckout: latestPaymentInfo.transaction_id,
        productId,
        createdAt: Date.now(),
      } satisfies PendingSubscriptionCheckout),
    );
  } catch {}
};

export const clearPendingSubscriptionCheckout = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {}
};

export const isPendingSubscriptionCheckoutExpired = (value: PendingSubscriptionCheckout) =>
  Date.now() - value.createdAt > TTL_MS;
